import importer from "common/importer";
const { deloitReq: req } = importer("APIs", null);
const Config = importer("Config");

let CORE_SCHEDULER_BASIC_AUTH;
if (Config.PLATFORM_TYPE != "mobile") {
  CORE_SCHEDULER_BASIC_AUTH = WEB_SCHEDULER_BASIC_AUTH;
}

/**
 * Fetch All Donors
 */
export const getAllDonors = (authToken) => {
  return req.get("/donors", {
    headers: {
      Authorization: authToken
    }
  });
};
/**
 * Fetch a Donor profile based on Heroku id, PDN or takedaId
 * @param {Number} id Heroku donor id
 */
export const getDonors = (id, authToken) => {
  return req.get(`/donors/${id}/profile`, {
    headers: {
      Authorization: `Basic ${Config.SCHEDULER_BASIC_AUTH || CORE_SCHEDULER_BASIC_AUTH}`
    }
  });
};
/**
 * Fetch a Donor profile based on Heroku id, PDN or takedaId
 * @param {Number} id Heroku donor id
 */
export const getDonorBySfid = (sfid, pid, authToken) => {
  return req.get(`/donors/profile?sfid=${sfid}&pid=${pid}`, {
    headers: {
      Authorization: `Basic ${Config.SCHEDULER_BASIC_AUTH || CORE_SCHEDULER_BASIC_AUTH}`
    }
  });
};

/**
 * Search for a Donor
 * @param {String} isGlobal
 * @param {String} phoneNumber
 * @param {String} PDN
 * @param {String} lastName
 * @param {String} firstName
 */
export const searchForDonor = (values, authToken) => {
  return req.get("donors/search-all", {
    headers: {
      Authorization: authToken
    },
    params: { ...values }
  });
};
/**
 * - Register a Donor
 * @param {Object} donor
 * @param {Object} donor.donorDetails
 * @param {String} donor.donorDetails.firstName
 * @param {String} donor.donorDetails.lastName
 * @param {String} donor.donorDetails.email
 * @param {String} donor.donorDetails.zipCode
 * @param {Boolean} donor.donorDetails.isMobileTermsAccepted
 * @param {String} donor.loginId
 */
export const registerDonor = (donor) => {
  return req.post("/donors/register", donor);
};
/**
 * Update donor details based on Heroku Id
 * @param {String} id
 * @param {Object} donor
 * -
 * - Example -
 * {
 *   "donorDetails": {
 *     "salutation": "string",
 *     "firstName": "string",
 *     "middleName": "string",
 *     "lastName": "string",
 *     "suffix": "Doctorate",
 *     "email": "string",
 *     "zipCode": "string",
 *     "birthDate": "string",
 *     "language": "English",
 *     "phoneNumber": "string",
 *     "personalMobilePhone": "string",
 *     "addressLine1": "string",
 *     "addressLine2": "string",
 *     "city": "string",
 *     "state": "string",
 *     "country": "string",
 *     "donationCenter": "string",
 *     "emergencyContactFirstName": "string",
 *     "emergencyContactLastName": "string",
 *     "emergencyContactPhone": "string",
 *     "emergencyContactRelation": "string",
 *     "ethnicity": "American Indian/Alaskan Native",
 *     "height": "string",
 *     "numOfChildrenForDaycare": "string",
 *     "donorLeadSource": "string",
 *     "isMobileTermsAccepted": true,
 *     "isSmsOptIn": true,
 *     "gender": "Male"
 *   },
 *   "verificationToken": "string",
 *   "takedaId": "string"
 * }
 */
export const updateDonor = (id, donor, authToken) => {
  delete donor?.donorDetails?.defaultCenter;
  const config = {
    headers: {
      Authorization: authToken
    }
  };
  return req.put("/donors/" + id + "/profile", donor, config);
};

/* NEW */

/**
 * DIS - Search for a Donor with PDN. All the supplied params will apply in conjunction
 * @param {String} lastName
 * @param {String} firstName
 * @param {String} pdn
 * @param {String} email
 * @param {String} phoneNumber
 * @param {String} city
 * @param {String} state
 * @param {String} centerNUm
 * @param {String} donationCenter
 */
export const searchActiveDonors = (lastName, firstName, pdn, email, phoneNumber, city, state, centerNum, donationCenter, authToken) => {
  return req.get("/donors/search-active-donors", {
    headers: {
      Authorization: authToken
    },
    params: {
      lastName,
      firstName,
      pdn,
      email,
      phoneNumber,
      city,
      state,
      centerNum,
      donationCenter
    }
  });
};

/**
 * DIS - Inquire a Donor. All the supplied params will apply in conjunction
 * @param {String} pdn
 */

export const inquiryDonor = (pdn, authToken) => {
  return req.get("/donors/inquiry", {
    headers: {
      Authorization: authToken
    },
    params: {
      pdn
    },
    withCredentials: true
  });
};

/**
 * DIS - Get Donors preferences. All the supplied params will apply in conjunction
 * @param {Integer} id
 */

export const getDonorsPreferences = (id, authToken) => {
  return req.get(`/donors/${id}/preferences`, {
    headers: {
      Authorization: authToken
    }
  });
};

/**
 * DIS - Update Donors preferences. All the supplied params will apply in conjunction
 * @param {Integer} id
 */

export const updateDonorsPreferences = (id, preferences, authToken) => {
  const config = {
    headers: {
      Authorization: authToken
    }
  };
  return req.put(`/donors/${id}/preferences`, preferences, config);
};

/**
 * Retrieve a Donor's lifetime donations
 */
export const getDonorLifetimeDonations = (authToken) => {
  const config = {
    headers: {
      Authorization: authToken
    }
  };
  return req.get(`/donors/lifetime-donations`, config);
};

/**
 * Retrieve a Donor's refer earned amount
 * @param {String} pdn
 * @param {String} authToken
 */
export const getDonorReferEarnedAmount = (pdn, authToken) => {
  return req.get("/donors/refer-earned-amount", {
    headers: {
      Authorization: authToken
    },
    params: {
      pdn
    }
  });
};
